import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vardhana-wallet',
  templateUrl: './vardhana-wallet.component.html',
  styleUrls: ['./vardhana-wallet.component.scss']
})
export class VardhanaWalletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
